import {Component, inject, OnInit} from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule, ValidationErrors,
  Validators
} from '@angular/forms';
import {CommonModule, NgClass, NgForOf, NgIf} from '@angular/common';
import {UserService} from '../../shared/services/user.service';
import {Router} from '@angular/router';
import {catchError, first, map, Observable, of} from 'rxjs';

@Component({
  selector: 'app-profile-setup',
  templateUrl: './profile-setup.component.html',
  styleUrls: ['./profile-setup.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgForOf,
    NgIf,
    NgClass,
    FormsModule
  ]
})
export class ProfileSetupComponent implements OnInit {
  avatars = ['croco.png', 'elephant.png', 'freak.png', 'koala.png', 'raccoon.png'];
  selectedAvatar: string = 'croco.png';

  private fb = inject(FormBuilder);
  private userService = inject(UserService);
  profileForm: FormGroup = this.fb.group({
    username: [
      '',
      [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(25),
        Validators.pattern(/^[a-zA-Z0-9_.]+$/)
      ],
      [this.usernameUniqueValidator()]
    ],
    email: [{value: this.userService.userProfile()?.email, disabled: true}],
    avatar: ['']
  });

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    if (!this.userService.userProfile()) {
      this.userService.loadUserProfile().subscribe({
        next: () => {
          this.profileForm.patchValue({
            email: this.userService.userProfile()?.email,
            avatar: this.userService.userProfile()?.avatar
          });
        }
      });
    }
  }

  get isFormValid(): boolean {
    return this.profileForm.valid && this.selectedAvatar !== null;
  }

  get username() {
    return this.profileForm.get('username');
  }

  usernameUniqueValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) return of(null);

      return this.userService.checkUsername(control.value).pipe(
        map((isAvailable: boolean) => (isAvailable ? null : {taken: true})),
        catchError(() => of<ValidationErrors | null>(null)),
        first()
      );
    };
  }

  selectAvatar(avatar: string): void {
    this.selectedAvatar = avatar;
    this.profileForm.patchValue({avatar});
  }

  submitProfile(): void {
    if (this.profileForm.valid) {
      const {username, avatar} = this.profileForm.value;

      const payload: { username?: string; avatar?: string } = {};
      if (username) payload.username = username;
      if (avatar) payload.avatar = avatar;

      this.userService.updateProfile({username, avatar}).subscribe({
        next: () => {
          console.log('Profile setup complete');
          this.router.navigate(['/dashboard']);
        },
        error: (err) => {
          console.error('Failed to update profile:', err);
          // Можно показать сообщение пользователю
          // this.errorMessage = 'Something went wrong. Please try again.';
        }
      });
    }
  }
}
